import { render, staticRenderFns } from "./SMSModal.vue?vue&type=template&id=56735805&scoped=true"
import script from "./SMSModal.vue?vue&type=script&lang=js"
export * from "./SMSModal.vue?vue&type=script&lang=js"
import style0 from "./SMSModal.vue?vue&type=style&index=0&id=56735805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56735805",
  null
  
)

export default component.exports